import localFont from 'next/font/local'

const helveticanow = localFont({
  src: [
    {
      path: './fonts/HelveticaNowDisplay-Light.woff2',
      weight: '300',
      style: 'normal'
    },
    {
      path: './fonts/HelveticaNowDisplay-Regular.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './fonts/HelveticaNowDisplay-Bold.woff2',
      weight: '700',
      style: 'normal'
    }
  ]
})

export type ThemeProps = Partial<{
  fluid: boolean
}>

// eslint-disable-next-line no-unused-vars
const Theme = ({ fluid = true }: ThemeProps) => {
  return (
    <style jsx global>{`
      :root {
        --font-family-helveticanow: ${helveticanow.style.fontFamily};

        --font-size: ${fluid
          ? `clamp(10px, ${(10 / 1440) * 100}vw, 12px)`
          : `10px`};

        --cols: 12;

        --grid-width: calc(
          144rem - var(--margin) * 2 - var(--gutter) * (var(--cols) - 1)
        );

        --col-span-1: calc(
          1 / var(--cols) * var(--grid-width) + var(--gutter) * 0
        );
        --col-span-2: calc(
          2 / var(--cols) * var(--grid-width) + var(--gutter) * 1
        );
        --col-span-3: calc(
          3 / var(--cols) * var(--grid-width) + var(--gutter) * 2
        );
        --col-span-4: calc(
          4 / var(--cols) * var(--grid-width) + var(--gutter) * 3
        );
        --col-span-5: calc(
          5 / var(--cols) * var(--grid-width) + var(--gutter) * 4
        );
        --col-span-6: calc(
          6 / var(--cols) * var(--grid-width) + var(--gutter) * 5
        );
        --col-span-7: calc(
          7 / var(--cols) * var(--grid-width) + var(--gutter) * 6
        );
        --col-span-8: calc(
          8 / var(--cols) * var(--grid-width) + var(--gutter) * 7
        );
        --col-span-9: calc(
          9 / var(--cols) * var(--grid-width) + var(--gutter) * 8
        );
        --col-span-10: calc(
          10 / var(--cols) * var(--grid-width) + var(--gutter) * 9
        );
        --col-span-11: calc(
          11 / var(--cols) * var(--grid-width) + var(--gutter) * 10
        );
        --col-span-12: calc(
          12 / var(--cols) * var(--grid-width) + var(--gutter) * 11
        );

        --col-start-1: calc(
          0 / var(--cols) * var(--grid-width) + var(--gutter) * 0
        );
        --col-start-2: calc(
          1 / var(--cols) * var(--grid-width) + var(--gutter) * 1
        );
        --col-start-3: calc(
          2 / var(--cols) * var(--grid-width) + var(--gutter) * 2
        );
        --col-start-4: calc(
          3 / var(--cols) * var(--grid-width) + var(--gutter) * 3
        );
        --col-start-5: calc(
          4 / var(--cols) * var(--grid-width) + var(--gutter) * 4
        );
        --col-start-6: calc(
          5 / var(--cols) * var(--grid-width) + var(--gutter) * 5
        );
        --col-start-7: calc(
          6 / var(--cols) * var(--grid-width) + var(--gutter) * 6
        );
        --col-start-8: calc(
          7 / var(--cols) * var(--grid-width) + var(--gutter) * 7
        );
        --col-start-9: calc(
          8 / var(--cols) * var(--grid-width) + var(--gutter) * 8
        );
        --col-start-10: calc(
          9 / var(--cols) * var(--grid-width) + var(--gutter) * 9
        );
        --col-start-11: calc(
          10 / var(--cols) * var(--grid-width) + var(--gutter) * 10
        );
        --col-start-12: calc(
          11 / var(--cols) * var(--grid-width) + var(--gutter) * 11
        );
      }

      @media (min-width: 768px) {
        :root {
        }
      }
    `}</style>
  )
}

export default Theme
